import { render, staticRenderFns } from "./QualificationGrade.vue?vue&type=template&id=0db384c2&"
import script from "./QualificationGrade.vue?vue&type=script&lang=js&"
export * from "./QualificationGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports